<template>
    <button class="btn btn--link" @click.prevent="download" :disabled="downloading">
        <SvgIcon :icon="'link'" />
        <span v-if="downloading">Downloading...</span>
        <span v-text="buttonTitle" />
    </button>
</template>
<script>
    import SvgIcon from './SvgIcon';
    import API from '@api';

    export default {
        name: 'AttachmentDownload',
        components: { SvgIcon },
        props: {
            attachment: {
                type: Object,
                required: true,
            },
            classes: {
                type: String,
                default: ''
            },
            title: {
                type: String,
                required: false,
                default: null,
            }
        },
        data() {
            return {
                downloading: false,
            }
        },
        computed: {
            buttonTitle: function() {
                if(this.title)
                    return this.title;

                if(this.attachment)
                    return `${this.attachment.filename} (${this.bytesToSize(this.attachment.filesize)})`;

                return "Download";
            }
        },
        methods: {
            download() {
                this.downloading = true;

                API.downloadAttachment(this.attachment.uuid, this.attachment.filename)
                    .finally(() => this.downloading = false);
            },
            bytesToSize: function(bytes) {
                if (bytes === 0) return '0 Byte';
                let sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
                let i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
                return Math.round(bytes / Math.pow(1024, i), 2) + ' ' + sizes[i];
            }
        }
    }
</script>
<style lang="scss" scoped>
    .btn {
        margin-left: auto;
        margin-right: 0;

        .svg-icon {
            height: 1.8rem;
            width: 1.8rem;
        }
    }
</style>
